module.exports = __webpack_public_path__ + "static/media/scriptPlacement.25427644.png";